[
  {
    "code": "WS-AA",
    "name": "A'ana"
  },
  {
    "code": "WS-AL",
    "name": "Aiga-i-le-Tai"
  },
  {
    "code": "WS-AT",
    "name": "Atua"
  },
  {
    "code": "WS-FA",
    "name": "Fa'asaleleaga"
  },
  {
    "code": "WS-GE",
    "name": "Gaga'emauga"
  },
  {
    "code": "WS-GI",
    "name": "Gagaifomauga"
  },
  {
    "code": "WS-PA",
    "name": "Palauli"
  },
  {
    "code": "WS-SA",
    "name": "Satupa'itea"
  },
  {
    "code": "WS-TU",
    "name": "Tuamasaga"
  },
  {
    "code": "WS-VF",
    "name": "Va'a-o-Fonoti"
  },
  {
    "code": "WS-VS",
    "name": "Vaisigano"
  }
]